import React from 'react'
import styled from 'styled-components'

const Shell = styled.div`
    min-height: 100vh;
    background: #f3f4f6;
`

const TopBar = styled.div`
    background: #1f4f9b;
    color: #fff;
    padding: 12px 24px;
    font-weight: 700;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
`

const BrandBadge = styled.span`
    background: #fff;
    color: #1f4f9b;
    width: 22px;
    height: 22px;
    border-radius: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 13px;
`

const Body = styled.div`
    max-width: 1240px;
    margin: 0 auto;
    padding: 24px 24px 56px;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;

    @media (max-width: 930px) {
        padding: 16px 12px 40px;
    }
`

export const PublicTicketShell = ({ children }) => (
    <Shell>
        <TopBar>
            <BrandBadge>e</BrandBadge>
            eAuditor — Ticket
        </TopBar>
        <Body>{children}</Body>
    </Shell>
)
